import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { EDIT_MODELS } from './constants';
import {
  EditModelsSuccess,
  EditModelsError,
  EditModelsDataActionTypes,
  EditModelsState,
} from './types';

const initialState: EditModelsState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: EditModelsDataActionTypes,
  ): EditModelsState => {
    switch (action.type) {
      case EDIT_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case EDIT_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as EditModelsSuccess).payload;
        break;
      }
      case EDIT_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as EditModelsError).error;
        break;
      }
      case EDIT_MODELS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
